export const games = [
  {
    gameId: 1,
    camera: "Camera 1",
    gameType: "Best of 1",
    gameName: "Biliard",
  },
  {
    gameId: 2,
    camera: "Camera 2",
    gameType: "Best of 5",
    gameName: "Metal Maze",
  },
  {
    gameId: 3,
    camera: "Camera 3",
    gameType: "Best of 3",
    gameName: "Piscina cu bureti",
  },
  {
    gameId: 4,
    camera: "Camera 4",
    gameType: "Best of 1",
    gameName: "Trivia",
  },
  {
    gameId: 5,
    camera: "Camera 5",
    gameType: "Best of 3",
    gameName: "Curling Table",
  },
  {
    gameId: 6,
    camera: "Camera 6",
    gameType: "Best of 3",
    gameName: "The floor is lava",
  },
  {
    gameId: 7,
    camera: "Camera 7",
    gameType: "Best of 3",
    gameName: "Tras cu Arcul",
  },
  {
    gameId: 8,
    camera: "Camera 8",
    gameType: "Best of 1",
    gameName: "GeoTrivia",
  },
  {
    gameId: 9,
    camera: "Camera 9",
    gameType: "Best of 3",
    gameName: "Wood Hockey",
  },
  {
    gameId: 10,
    camera: "Camera 10",
    gameType: "Best of 3",
    gameName: "Tetris",
  },
  {
    gameId: 11,
    camera: "Camera 11",
    gameType: "Best of 3",
    gameName: "Catch It ",
  },
];
